module.exports = __webpack_public_path__ + "static/media/PDF.619a92b9.svg";